
import React from 'react';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons'

@observer
export default class Page404 extends React.Component {

  render(){
    const currentUrl = window.location.href;
    const imgArray = ['/img/cat_hungry.png', '/img/facepalm.gif', '/img/cat_cage.png'];
    const img = imgArray[Math.floor(Math.random() * imgArray.length)];

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="error-template">

              <img src={img} className="top-image" />
              <h1>
                Oops!</h1>
              <h2>
                404 Not Found</h2>
              <div className="error-details">
                Sorry, an error has occured, Requested page not found <br/>
                (You are trying to access page &quot;<b>{currentUrl}</b>&quot;)
              </div>
              <div className="error-actions">
                <a href="/" className="btn btn-primary">
                  <FontAwesomeIcon className="options-note context-menu-target" icon={faHome}/>
                  &nbsp;Take Me Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}